export default "__VITE_PUBLIC_ASSET__3066f6fb__"